<template>
  <div class="dashboard reviews">
    <div class="navbar">
      <div class="left">
        <div class="title">
          <div class="wrap">
            <h4>Отслеживание новых отзывов</h4>
            <div class="sub-title">Новые отзывы с отслеживаемых ссылок. Добавить ссылки на отслеживание можно в
              <router-link to="/settings">настройках проекта</router-link>
            </div>

          </div>
        </div>
        <TopBlock :no-data="true"></TopBlock>
      </div>

    </div>
    <button class="btn btn-outline-secondary show-filters" @click="openFilter=!openFilter">
      <i class="bi bi-filter"></i>
      <template v-if="openFilter">Скрыть</template>
      <template v-else>Показать</template>
      фильтры
    </button>
    <div :class="'filters'+(openFilter?' open':'')">
      <div class="links">
        <div class="link" v-for="link in links">
          <label @click="addToFilter(link.id)"
                 :class="'btn btn'+(this.links_ids.indexOf(link.id) <0?'-outline':'')+'-dark'">{{ link.link }}</label>
        </div>
      </div>

    </div>
    <div :class="'filters'+(openFilter?' open':'')">
      <MultiSelect v-model="filters.answers"
                   :options="$ANSWERS"
                   :multi="false"
                   :showLabel="true"
                   :only_value="true"
                   name="Наличие ответа"></MultiSelect>
      <MultiSelect v-model="filters.answered"
                   :options="[{id: 0, name: 'Нет'},{id: 1, name: 'Да'}]"
                   :multi="false"
                   :showLabel="true"
                   :only_value="true"
                   name="Отвечено"></MultiSelect>
      <MultiSelect v-model="filters.ratings"
                   :options="$RATING"
                   :multi="true"
                   :only_value="true"
                   name="Оценки"></MultiSelect>
      <button class="btn btn-primary me-2" @click="getData">Показать</button>

    </div>

    <div :class="'filters stat'+(openFilter?' open':'')">
      <div class="data">
        Всего отзывов: <b>{{ all_count }}</b> <span class="separate">|</span>
        Показано: <b>{{ reviews.length }}</b> <span class="separate">|</span>
        <div class="tones">
          <div class="point"></div>
          Позитив: <b>{{ reviews.filter(x => x.tone === "positive").length }}</b>
          <div class="point negative"></div>
          Негатив: <b>{{ reviews.filter(x => x.tone === "negative").length }}</b>
        </div>
      </div>
    </div>


    <div class="responses">
      <template v-for="review in reviews">
        <SmallReview :review="review" :show_answered="true" :tags="tags" @update-review="handleReviewUpdate"></SmallReview>
      </template>
      <div v-if="!reviews.length && load" class="empty-state">
        <i class="bi bi-chat-left-dots-fill"></i>


        <p v-if="!links.length">Нет ссылок добавленных на отслеживание</p>
        <p v-else>Здесь пока нет новых отзывов</p>

        <span>
          Это дашборд для мониторинга репутации. <br>
          Как только кто-то оставит отзыв по одной из отслеживаемых вами ссылок, <br> он появится в этой ленте,
          а вы получите уведомление в Telegram и на почту</span><br>
        <template v-if="!links.length">
          <div class="hint">
          <span>Чтобы настроить отслеживание:</span>
          <ul>
            <li> Перейдите в раздел «<router-link to="/settings">Настройки проекта</router-link>».</li>

            <li>Найдите блок «Управление ссылками».</li>
            <li>В списке ссылок найдите нужные страницы </li>

            <li>Отметьте их с помощью чекбокса с иконкой будильника — это активирует мониторинг.</li>
          </ul>
            </div>
        </template>
      </div>


      <PagerList class="mt-3" v-bind:pager="response_pager" v-bind:updatePage="updateResponsePage"
                 v-bind:page="page"></PagerList>
    </div>

  </div>


</template>

<script>


import TopBlock from "@/components/TopBlock.vue";
import {ReviewApi} from "@/api/reviews";
import {ProjectApi} from "@/api/projects";
import PagerList from "@/components/PagerList.vue";
import datesMixin from "@/mixins/filterDates";
import {LinksApi} from "@/api/links";
import SmallReview from "@/views/dictionary/review/components/SmallReview.vue";
import {state} from "@/socket";

export default {
  name: 'ProjectAlerts',
  data() {
    return {
      reviews: [],
      links: [],
      tags: [],
      page: 1,
      size: 20,
      all_count: 0,
      openFilter: false,
      links_ids: [],
      load: false,
      filters: {
        answers: null,
        answered: null,
        ratings: [],
      },

    }
  },
  mixins: [datesMixin],
  watch: {
    page(old, new_val) {
      // this.updateURL()
      this.getData()
    },
    links_ids: {
      handler(val) {
        this.getData()
      },
      deep: true
    },
    state_review(value) {
      if (value.link.project == this.project_id) {
        this.reviews.unshift(value);
        this.highlightReview(value.id)
      }

    },
  },
  components: {SmallReview, PagerList, TopBlock},

  computed: {

    state_review(value) {
      return state.review
    },
    response_pager: {
      get() {
        return this.response_pager = this.$func.getPagerArray(this.all_count, this.size, this.page)
      },
      set() {
      }
    },

    project_id: {
      get() {
        return this.$store.getters.currentProjectId
      },
      set(value) {
      }
    }
  },
  mounted: function () {
      LinksApi.get_list(1, 100, 'checker=true').then(response => this.links = response.results)
    ProjectApi.reviews_tags(this.$store.getters.currentProjectId, 1, 200).then(response => {
      this.categoriesTag = response
      this.getData()
      this.categoriesTag.forEach(category => {
        this.tags = this.tags.concat(category.tags)
      })

    })

  },
  methods: {
    handleReviewUpdate({ id, data }) {
      const index = this.reviews.findIndex(r => r.id === id);

      if (index !== -1) {
        this.reviews[index] = data;
      }
    },
    highlightReview(id) {
      const element = document.getElementById(`review_${id}`);
      if (!element) {
        return;
      }
      const previousHighlight = document.querySelector('.highlight-effect');
      if (previousHighlight) {
        previousHighlight.classList.remove('highlight-effect');
      }

      element.classList.add('highlight-effect');

      setTimeout(() => {
        element.classList.remove('highlight-effect');
      }, 2000);
    },
    addToFilter(id) {
      if (this.links_ids.indexOf(id) >= 0) {
        this.links_ids.splice(this.links_ids.findIndex(x => x === id), 1)
      } else this.links_ids.push(id)
    },

    updateResponsePage(page) {
      this.page = page
    },

    getData() {
      let filters = JSON.parse(JSON.stringify(this.filters))
      filters.order_by = "-date_response"
      filters.link_ids = this.links_ids.join(',')
      filters.checker = true


      const searchParams = new URLSearchParams();
      for (const [key, value] of Object.entries(filters)) {
        if (value === null || value === undefined) {
          continue;
        }
        if (Array.isArray(value)) {
          value.forEach(item => {
            if (item !== null && item !== undefined && item !== '') {
              searchParams.append(key, item);
            }
          });
        } else if (value !== '') {
          searchParams.append(key, value);
        }
      }

      const queryString = searchParams.toString();
      ReviewApi.get_reviews(this.page, this.size, queryString).then(response => {
        this.reviews = response.results
        this.all_count = response.count;
        this.load = true
      })
    }
  }
}

</script>
<style scoped lang="scss">


.responses {
  display: flex;
  flex-direction: column;
  gap: 15px;

}

.links {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;

  label {
    font-size: 14px;
    border-radius: 20px;
  }
}


@media (width < 768px) {

  .responses {
    margin-bottom: 80px;
  }
}

.empty-state {
  text-align: center;
  padding: 40px 20px;
  color: #868e96;

  i {
    font-size: 48px;
    color: #dee2e6;
    display: block;
    margin-bottom: 12px;
  }

  p {
    font-size: 16px;
    font-weight: 500;
    margin: 0;
    color: #495057;
  }


  .hint {
    font-size: 13px;
    color: #adb5bd;
    width: 370px;
    text-align: left;
    margin: 0 auto;
  }
}

</style>
